import startCase from 'lodash/startCase'

function decodeLocation(str: string) {
  return startCase(decodeURIComponent(str))
}

function encodeLocation(location: string) {
  return encodeURIComponent(location.replace(/\s+/g, '-').toLowerCase())
}

/**
 * update agentSeeker global object, so that fantasia can access it
 */
export function updateLocationObject(city: string, state: string) {
  //@ts-ignore
  if (!globalThis.agentSeeker) globalThis.agentSeeker = {}
  globalThis.agentSeeker.location = { city, stateCode: state }
}

/**
 * Update <title> tag
 */
export function updateTitleTag(city: string, state: string) {
  let title = 'Find Real Estate Agents & Realtors '
  if (city && state) {
    title += `in ${decodeLocation(city)}, ${state.toUpperCase()}`
  } else {
    title += 'Near Me'
  }

  title += ' | Bankrate'

  if (typeof document !== 'undefined') {
    document.title = title
  }

  return title
}

/**
 * Update <h1> tag
 */
export function updateHeadings(city: string, state: string) {
  const html =
    city && state
      ? `${decodeLocation(city)}, ${decodeLocation(
          state
        )} Real Estate Agents and Realtors`
      : `Real Estate Agents and Realtors`

  if (typeof document !== 'undefined') {
    const h1 = document.getElementById('title-line')
    if (h1) h1.innerHTML = html
  }

  updateMyfiHeading(city, state)

  return html
}

/**
 * Update url to include city and state
 * Update canonical url
 */
export function populateLocationInUrl(city: string, state: string) {
  if (city && state) {
    const currentUrl = new URL(window.location.href)

    currentUrl.pathname = `/real-estate/agents/${encodeLocation(
      state
    )}/${encodeLocation(city)}/`

    const newUrl = currentUrl.toString()

    globalThis.history.replaceState(null, document.title, newUrl)

    const canonical = document.querySelector('link[rel="canonical"]')

    if (canonical) {
      canonical['href'] = window.location.origin + currentUrl.pathname
    }

    return newUrl
  }
}

/**
 * Update <meta name="robots"> tag
 */
export function allowSeachEngineIndex(allowIndex: boolean) {
  // TODO: remove env check on launch day
  const content =
    allowIndex && process.env.NEXT_PUBLIC_APP_ENV !== 'prod'
      ? 'index, follow'
      : 'noindex, nofollow'

  const robots = document.querySelector('meta[name="robots"]')

  if (robots) {
    robots['content'] = content
  } else {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = content
    document.head.appendChild(meta)
  }
}

/**
 * update the myfi heading, which is outside of the react app
 */
function updateMyfiHeading(city: string, state: string) {
  if (city && state && typeof document !== 'undefined') {
    const heading = document.getElementById('im-header')
    if (heading) {
      heading.innerHTML = `Find A Real Estate Agent Near ${decodeLocation(
        city
      )}, ${decodeLocation(state)}`
    }
  }
}

export function getHostURL(env: string) {
  switch (env) {
    case 'local':
      return 'http://localhost:3000'
    case 'qa':
      return 'https://qa.bankrate.com'
    default:
      return 'https://www.bankrate.com'
  }
}
